const LocationReviewsData = [
  {
    "customer": "Michael S.",
    "review": "Exceptional service! The team was punctual, friendly, and thoroughly cleaned my chimney. I noticed better airflow and warmth right away.",
    "service": "Chimney Cleaning"
  },
  {
    "customer": "Jessica T.",
    "review": "AttiAir exceeded my expectations. They cleaned the chimney and resolved some draft issues. Highly recommend!",
    "service": "Chimney Cleaning"
  },
  {
    "customer": "Emily R.",
    "review": "Great experience from start to finish. The technicians were knowledgeable, explained the process, and left everything spotless.",
    "service": "Chimney Cleaning"
  },
  {
    "customer": "Anthony J.",
    "review": "Efficient, professional, and reliable. I appreciate how the team paid attention to every detail. My home feels warmer.",
    "service": "Chimney Cleaning"
  },
  {
    "customer": "Robert K.",
    "review": "Quick response time and thorough chimney cleaning. I’m breathing easier, and it’s all thanks to AttiAir.",
    "service": "Chimney Cleaning"
  },
  {
    "customer": "Sarah P.",
    "review": "They did an amazing job with my chimney. The team was respectful of my home and got the job done quickly.",
    "service": "Chimney Cleaning"
  },
  {
    "customer": "Lisa M.",
    "review": "Very impressed with the quality of service. The technicians were polite and took care of everything efficiently.",
    "service": "Chimney Cleaning"
  },
  {
    "customer": "Kevin H.",
    "review": "AttiAir provided excellent service, and I noticed less soot in the house immediately after the cleaning.",
    "service": "Chimney Cleaning"
  },
  {
    "customer": "Diana F.",
    "review": "This was my first time using them, and I’ll definitely call again. Great value and fantastic results.",
    "service": "Chimney Cleaning"
  },
  {
    "customer": "Eric W.",
    "review": "The technicians were professional and completed the cleaning quickly. My fireplace is running smoother now.",
    "service": "Chimney Cleaning"
  },
  {
    "customer": "Samantha L.",
    "review": "The team did a fantastic job repairing our chimney cap. It was long overdue, and now we have no more leaks!",
    "service": "Chimney Repair"
  },
  {
    "customer": "Tom C.",
    "review": "AttiAir saved us from a potential fire hazard by thoroughly repairing the chimney. Very grateful!",
    "service": "Chimney Repair"
  },
  {
    "customer": "Olivia N.",
    "review": "Highly recommend their chimney repair service. They arrived on time and finished the job without any mess.",
    "service": "Chimney Repair"
  },
  {
    "customer": "Jason B.",
    "review": "I could tell they knew exactly what they were doing. Our chimney works more efficiently, thanks to their excellent service.",
    "service": "Chimney Repair"
  },
  {
    "customer": "Maria S.",
    "review": "AttiAir did an amazing job repairing our chimney. I never realized how much damage could accumulate over time!",
    "service": "Chimney Repair"
  },
  {
    "customer": "Peter V.",
    "review": "Quick, efficient, and friendly service. I’ll be scheduling regular chimney inspections with them.",
    "service": "Chimney Repair"
  },
  {
    "customer": "Vanessa D.",
    "review": "Outstanding service! The techs were knowledgeable and explained the importance of regular chimney repairs.",
    "service": "Chimney Repair"
  },
  {
    "customer": "Ben A.",
    "review": "I had significant damage to my chimney, but BHO handled it well. Great job!",
    "service": "Chimney Repair"
  },
  {
    "customer": "Amy G.",
    "review": "They were able to schedule me quickly and did a thorough job. I appreciate their attention to safety.",
    "service": "Chimney Repair"
  },
  {
    "customer": "Rachel K.",
    "review": "Very pleased with the chimney repair. The team was professional, and I can already tell the difference in heating efficiency.",
    "service": "Chimney Repair"
  },
  {
    "customer": "Alex P.",
    "review": "The team found and fixed a crack in our chimney that I didn't even know existed. Great service!",
    "service": "Chimney Repair"
  },
  {
    "customer": "Brandon L.",
    "review": "Had a repair done on my chimney, and they did an excellent job. The safety inspection was thorough.",
    "service": "Chimney Repair"
  },
  {
    "customer": "Nina J.",
    "review": "They quickly identified and fixed the issue with my chimney. I’m very happy with the results.",
    "service": "Chimney Repair"
  },
  {
    "customer": "Trevor M.",
    "review": "AttiAir repaired a crack in our chimney. It’s working much better now, and we’re very satisfied.",
    "service": "Chimney Repair"
  },
  {
    "customer": "Katie W.",
    "review": "The team was able to repair some chimney damage and improve our home's safety. Highly recommend.",
    "service": "Chimney Repair"
  },
  {
    "customer": "Chris B.",
    "review": "The technicians did a thorough inspection and fixed some issues we weren't aware of. Great job!",
    "service": "Chimney Repair"
  },
  {
    "customer": "Megan R.",
    "review": "Very satisfied with their service. They identified and repaired some leaks in our chimney.",
    "service": "Chimney Repair"
  },
  {
    "customer": "Danny H.",
    "review": "The repair work on our chimney was quick, and the results were excellent. I appreciate their professionalism.",
    "service": "Chimney Repair"
  },
  {
    "customer": "Lauren T.",
    "review": "AttiAir did a wonderful job repairing our chimney. The fireplace is now safer and more efficient.",
    "service": "Chimney Repair"
  },
  {
    "customer": "Rick A.",
    "review": "They were able to repair the issues in our chimney promptly. I’m very pleased with their service.",
    "service": "Chimney Repair"
  },
  {
    "customer": "Ashley E.",
    "review": "The techs were professional and repaired the chimney efficiently. Our home feels more comfortable now.",
    "service": "Chimney Repair"
  },
  {
    "customer": "Monica G.",
    "review": "The team was able to fix a crack in my chimney that was affecting the air quality. Great job!",
    "service": "Chimney Repair"
  },
  {
    "customer": "Hank F.",
    "review": "I was impressed by their thorough inspection and repair work. They really know what they're doing.",
    "service": "Chimney Repair"
  },
  {
    "customer": "Jasmine K.",
    "review": "AttiAir repaired and cleaned our chimney. The service was fantastic, and the results are noticeable.",
    "service": "Chimney Repair"
  }
]
  
export default LocationReviewsData;
